import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const orderSlice = createApi({
    reducerPath: "orderSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getOrders: builder.query({
            query: ({ page = 1, limit = 10, search = "", orderType = "" }) => ({
                url: `/booking/list?orderType=${orderType}&page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),


        // ✅ Delete Category
        deleteTimeslot: builder.mutation({
            query: (id) => ({
                url: `/timeSlot/${id}`,
                method: "DELETE",
            }),
        }),
        cancelBooking: builder.mutation({
            query: ({ id, status }) => ({
                url: `/booking/booking-cancel/${id}`,
                method: "PUT",
                body: { reason: status }
            }),
        }),
        rescheduleBooking: builder.mutation({
            query: ({ id, rescheduleDate, rescheduleSlot, rescheduleReason }) => ({
                url: `/booking/reschedule/${id}`,
                method: "PUT",
                body: { bookingDate: rescheduleDate, bookingTime: rescheduleSlot, reason: rescheduleReason }
            }),
        }),

        addNote: builder.mutation({
  query: ({ id, note }) => ({
    url: `/booking/addNote/${id}`,
    method: "PUT",
    body: { note },
  }),
}),

    }),
});

export const {
    useGetOrdersQuery,
    useAddNoteMutation,
    useDeleteTimeslotMutation,
    useCancelBookingMutation,
    useRescheduleBookingMutation
} = orderSlice;
